import { min } from "date-fns";

export const lg_meet_page = {
  meet_page_th: {
    input_password: "ระบุ รหัสผ่าน",
    label_password: "รหัสผ่าน",
    btn_save: "บันทึก",
    invalid_url: "URL ไม่ถูกต้อง",
    invalid_password: "รหัสผ่าน ไม่ถูกต้อง",
    dialog_check_data: "กรุณาตรวจสอบข้อมูล",
    input_name: "ระบุชื่อ",
    join_meeting: "เข้าร่วมประชุม",
    btn_enter: "ตกลง",
    title_error: "ผิดพลาด",
    btn_confirm1: "ส่งอีเมล OTP",
    email1: "อีเมล",
    title2: "ยืนยัน OTP",
    txt_otp: "OTP",
    dialog_popup_success: "ส่ง OTP สำเร็จ",
    dialog_popup_success_message: "กรุณาตรวจ OTP ที่อีเมล์",
    dialog_popup_fail: "ส่ง OTP ล้มเหลว",
    dialog_popup_fail_message: "กรุณาส่ง OTP ใหม่อีกครั้ง",
    dialog_popup_expire: "OTP หมดอายุ",
    dialog_popup_expire_message: "OTP หมดอายุ กรุณาส่ง OTP ใหม่อีกครั้ง",
    confirmotp_fail_title:"รหัส OTP ไม่ถูกต้อง",
    confirmotp_fail:"รหัส OTP ไม่ถูกต้อง โปรดลองอีกครั้ง",
    enter_email:"กรอกอีเมล",
    enter_sub_email:"ห้องประชุมนี้ต้องการ การยืนยัน OTP กรุณากรอกอีเมลของคุณเพื่อรับ OTP",
    enter_otp:"กรอก OTP",
    enter_sub_otp:"กรอก OTP ที่ส่งไปยังอีเมลของคุณเพื่อยืนยันและเข้าร่วมการประชุม",
    theotpyou_entered:"OTP ที่คุณป้อนไม่ถูกต้อง กรุณาขอรหัส OTP ใหม่อีกครั้ง",
    resubmit:"ส่งใหม่อีกครั้ง",
    require_login:"ต้องเข้าสู่ระบบ",
    require_sub_login:"ต้องยืนยันตัวตนเพื่อเข้าร่วมการประชุมนี้",
    require_sub_login2:"กรุณาเข้าสู่ระบบ Dmeets ก่อนเข้าร่วมการประชุม",
    login:"เข้าสู่ระบบ",
    request_a_new_otp:"ขอรหัส OTP ใหม่",
    participant_limit_reached:"จำกัดจำนวนผู้เข้าร่วม",
    participant_limit_reached_dtails1_free:"แผนฟรีรองรับผู้เข้าร่วมได้สูงสุด 10 คนต่อการประชุม",
    participant_limit_reached_dtails2_free:"อัปเกรดเป็นแผน โปร เพื่อเข้าร่วมได้สูงสุดถึง 50 คน",
    participant_limit_reached_dtails1_pro:"แผนโปรรองรับผู้เข้าร่วมได้สูงสุด 50 คนต่อการประชุม",
    participant_limit_reached_dtails2_pro:"อัปเกรดเป็นแผน ธุรกิจ เพื่อเข้าร่วมได้สูงสุดถึง 100 คน",
    participant_limit_reached_dtails1_business:"แผนธุรกิจรองรับผู้เข้าร่วมได้สูงสุด 100 คนต่อการประชุม",
    participant_limit_reached_dtails2_business:"อัปเกรดเป็นแผน องค์กร เพื่อเข้าร่วมได้ไม่จำกัดจำนวนผู้เข้าร่วม",
    free_meeting_ended:"การประชุมสิ้นสุดแล้ว",
    free_meeting_ended_details1:"คุณได้ใช้เวลาครบ 40 นาทีตามข้อกำหมดของแผนฟรี",
    free_meeting_ended_details2:"อัปเกรดเวลาการประชุมไม่จำกัดด้วย Dmeets Pro",
    btn_upgrade_now:"อัปเกรดตอนนี้",
    btn_back_to_home: "กลับสู่หน้าหลัก",
    meeting_not_started_yet:"การประชุมยังไม่เริ่ม",
    meeting_not_started_yet_details1:"การประชุมนี้มีกำหนดเริ่มเวลา",
    meeting_not_started_yet_details2:"ระบบจะรีเฟรชหน้านี้โดยอัตโนมัติในอีก",
    meeting_not_started_yet_details3:"เพื่อให้คุณเข้าร่วมประชุม",
    refresh_now:"รีเฟรชตอนนี้",
    day:"วัน",
    minute:"นาที",
    hours:"ชั่วโมง",
    second:"วินาที",
    popup_recording_title: "การประชุมนี้กำลังถูกบันทึก",
    popup_recording_details:"หากท่านยังคงอยู่ในการประชุม ถือว่าท่านให้ความยินยอมต่อการบันทึกเสียง ภาพ และเนื้อหาที่แชร์",
    popup_recording_title_stop: "การบันทึกถูกหยุดแล้ว",
    popup_recording_details_stop_1:"การบันทึกสำหรับการประชุมนี้ได้ถูกหยุดแล้ว",
    popup_recording_details_stop_2:"จะไม่มีการบันทึกเสียงหรือวิดีโอเพิ่มเติม",
    popup_recording_ok:"ตกลง",

  },
  meet_page_en: {
    input_password: "Enter password",
    label_password: "Password",
    btn_save: "Save",
    invalid_url: "Invalid URL",
    invalid_password: "Invalid password",
    dialog_check_data: "Please check your information",
    input_name: "Enter Name",
    join_meeting: "Join Meeting",
    btn_enter: "Enter",
    title_error: "Error",
    btn_confirm1: "Send Email OTP",
    email1: "Email",
    title2: "Verify OTP",
    txt_otp: "OTP",
    dialog_popup_success: "Sent OTP successful",
    dialog_popup_success_message: "Please check OTP in your email",
    dialog_popup_fail: "Send OTP failed",
    dialog_popup_fail_message: "Please send OTP again",
    dialog_popup_expire: "OTP Expired",
    dialog_popup_expire_message: "OTP has expired, please send the OTP again",
    confirmotp_fail_title:"Invalid OTP",
    confirmotp_fail:"Invalid OTP Please try again",
    enter_email:"Enter Email",
    enter_sub_email:"This meeting room requires OTP verification. Please enter your email to receive the OTP.",
    enter_otp:"Enter OTP",
    enter_sub_otp:"Enter the OTP sent to your email to verify and join the meeting.",
    theotpyou_entered:"The OTP you entered is incorrect. Please resend a new OTP.",
    resubmit:"Resubmit",
    require_login:"Require Login",
    require_sub_login:"Authentication is required to join this meeting",
    require_sub_login2:"This meeting room requires logging into Dmeets",
    login:"Login",
    request_a_new_otp:"Request new OTP",
    participant_limit_reached:"Participant limit reached",
    participant_limit_reached_dtails1_free:"The Free Plan supports up to 10 people per meeting.",
    participant_limit_reached_dtails2_free:"Upgrade to Pro for up to 50 participants.",
    participant_limit_reached_dtails1_pro:"The Pro Plan supports up to 50 people per meeting.",
    participant_limit_reached_dtails2_pro:"Upgrade to Business for up to 100 participants.",
    participant_limit_reached_dtails1_business:"The Business Plan supports up to 100 people per meeting.",
    participant_limit_reached_dtails2_business:"Upgrade to Enterprise for up to Unlimited participants.",
    free_meeting_ended:"Meeting ended",
    free_meeting_ended_details1:"You’ve hit the 40-minute limit for Free Plan meetings.",
    free_meeting_ended_details2:"Unlock unlimited time with Dmeets Pro.",
    btn_upgrade_now:"Upgrade Now",
    btn_back_to_home: "Back to Home",
    meeting_not_started_yet:"Meeting Not Started Yet",
    meeting_not_started_yet_details1:"This meeting is scheduled to begin at",
    meeting_not_started_yet_details2:"The page will automatically refresh in",
    meeting_not_started_yet_details3:" to allow you to join.",
    refresh_now:"Refresh Now",
    day:"Day",
    hours:"Hour",
    minute:"minute",
    second:"second",
    popup_recording_title:"This meeting is being recorded.",
    popup_recording_details:"By remaining in the meeting, you consent to the recording of your audio, video, and shared content.",
    popup_recording_title_stop: "Recording Stopped",
    popup_recording_details_stop_1:"Recording for this meeting has been stopped.",
    popup_recording_details_stop_2:"No further audio or video is being recorded.",
    popup_recording_ok:"OK",

  },
};

